export const getYearsOld = (dateString: string) => {
  let hoy = new Date();
  let fechaNacimiento = new Date(dateString);
  let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
  let diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth();
  if (
    diferenciaMeses < 0 ||
    (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())
  ) {
    edad--;
  }
  return edad;
};

export const getDay = () => new Date().getDate();
export const getMonth = () => new Date().getMonth();
export const getYear = () => new Date().getFullYear();

export const currentMonthDays = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-indexed: enero = 0

  const days = [];
  const lastDay = new Date(year, month + 1, 0).getDate(); // Último día del mes

  for (let day = 1; day <= lastDay; day++) {
    days.push(new Date(year, month, day).getDate());
  }

  return days;
}

export const currentMonthRestDays = (start: number) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-indexed: enero = 0

  const days = [];
  const lastDay = new Date(year, month + 1, 0).getDate(); // Último día del mes

  for (let day = start; day <= lastDay; day++) {
    days.push(new Date(year, month, day).getDate());
  }

  return days;
}

export const formatQueryDate = (year: number, month: number, day: number) => new Date(year, month, day).toISOString();
export const formatDate = (date: string | Date) => new Date(date).toISOString();
